import { SortIcon } from "components/Table_SortColumnIcon"

const usersListColumns = () => {
  return [
    {
      text: "id",
      dataField: "user_id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.user_id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, row) => {
        return (
          <>
            {row.first_name} {row.last_name}{" "}
            {row.viewed_exp ? "" : <em>(Unviewed)</em>}
          </>
        )
      },
    },
    {
      text: "Email",
      dataField: "email",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => <>{user.email}</>,
    },
    {
      text: "User Status",
      dataField: "user_status",
      formatter: (cellContent, user) => <>{user.user_status}</>,
    },
    {
      text: "Access Type",
      dataField: "rsvp_string_type",
      formatter: (cellContent, user) => <>{user.rsvp_string_type}</>,
    },
    {
      text: "Email Last Sent",
      dataField: "last_sent",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => (
        <>{user.last_sent ? user.last_sent : "Never sent"}</>
      ),
    },
    {
      text: "Email Status",
      dataField: "status",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => <>{user.status}</>,
    },
  ]
}

export default usersListColumns
